import { useQuery } from '@tanstack/react-query';
import { fetchDevices } from '../services/api';
import { UnifiedDeviceListResponse } from '../types/device';

export function useDevices(opts: {
  page?: number;
  limit?: number;
  search?: string;
  mac?: string;
  sn?: string;
  tenant?: string;
  enabled?: boolean;
}) {
  const { page = 1, limit = 20, search, mac, sn, tenant = 'TGStream', enabled = true } = opts;

  return useQuery<UnifiedDeviceListResponse, Error>({
    queryKey: ['devices', page, limit, search, mac, sn, tenant],
    queryFn: () => fetchDevices({ page, limit, search, mac, sn, tenant }),
    staleTime: 10_000,
    enabled,
  });
}
